<template>
    <form  id="pt041" class="pt041">
        <div class="categoryMain">
            <ul id="subMenu" class="subMenu">
                <tree :tree-data="pt041CategoryList" :children="'SUBCATEGORY'" :label="'CATEGORY_NM'" :value="'CATEGORY_CD'" @selectNode="selectNode" :marginLeft="'35px'"></tree>
            </ul>
        </div>
    </form>   
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import EventBus from 'assets/js/eventBus';
import Tree from "../commonParts/Tree";
import SiteConstants from 'assets/const/SiteConstants.json';
export default {
    /* 
    * Name of component
    */
    name: "PT041CategoryShowParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Get data from parent component
    */
    components:
    {
        Loading,
        EventBus,
        Tree
    },
    data() {
        return {
            pt041CategoryList:{},
            isLoading: false,
            listIdErr:[],
            pt041ReqModel:{},
            SiteConstants: SiteConstants,
            site: ""
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        // eslint-disable-next-line
        if (_this.ptInitData){
            _this.pt041CategoryList = _this.ptInitData.categoryList;
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT041 + _this.$UrlConstants.DO_INIT ,_this.pt041ReqModel).then(function(response) {
                _this.pt041CategoryList = response.data.categoryList;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }

    },
    methods: {
        selectNode: function(categoryCd) {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG020,params: {pageNo: 2, categoryCd : categoryCd}});
        },
    },
}
</script>

